export enum BtmReturnRequestType {
    PhysicalReturn = "PhysicalReturn",
    AnticipatedRefundOnExpectedPhysicalReturn = "AnticipatedRefundOnExpectedPhysicalReturn",
    VirtualReturn = "VirtualReturn",
}

export const BuildBtmReturnRequestTypeFromString = (type: string) => {
    switch (type) {
        case "AnticipatedRefundOnExpectedPhysicalReturn":
            return BtmReturnRequestType.AnticipatedRefundOnExpectedPhysicalReturn;
        case "VirtualReturn":
            return BtmReturnRequestType.VirtualReturn;
        case "PhysicalReturn":
        default:
            return BtmReturnRequestType.PhysicalReturn;
    }
};
